/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ElectoralFinanaceReportsInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Electoral Finance Reports"
              description={
               <>
               <h4>Political Donations Annual Reports</h4>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><u><a href="/files/ElectoralFinanceReports/PoliticalContributionsRegime_2023.pdf">Political Donations Annual Report 2023</a></u></li> <br />
                  </ul>
                  <br />
                  <h4>Registered Party Audited Financial Statements</h4>
                  <br />
                  The Elections Act requires registered political parties in Nova Scotia to submit an independently audited financial statement to Elections Nova Scotia annually by April 30th. Elections Nova Scotia posts these statements here on our website in accordance with legislation each year in early May.
                  <br/>  <br/>
                  <h4>2023</h4>  <br/>
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><u><a href="/files/ElectoralFinanceReports/Green Party Financial Statement.pdf">Green Party of Nova Scotia</a></u></li><br />
                    <li><u><a href="/files/ElectoralFinanceReports/Liberal Financial Statement 2023_1.pdf">Liberal Association of Nova Scotia</a></u></li><br />
                    <li><u><a href="/files/ElectoralFinanceReports/NDP 2023_financial_statements.pdf">Nova Scotia New Democratic Party</a></u></li><br />
                    <li><u><a href="/files/ElectoralFinanceReports/NS United 2023FS.pdf">Nova Scotians United</a></u></li><br />
                    <li><u><a href="/files/ElectoralFinanceReports/PC Party Financial Statement.pdf">The Progressive Conservative Association of Nova Scotia</a></u></li><br />
                  </ul>
               </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ElectoralFinanaceReportsInformation;
